import { filemakerService } from './filemakerService.js';

/**
 * Servicio para gestión de usuarios usando FileMaker
 */
export class UsersService {
  /**
   * Obtener todos los usuarios con filtros opcionales
   */
  static async getUsers(filters = {}) {
    try {
      const response = await filemakerService.findRecords('yoolusers', {
        query: filters.search ? [
          {
            "email": `*${filters.search}*`,
            "full_name": `*${filters.search}*`
          }
        ] : undefined,
        sort: [{ fieldName: "MarcaFechaYHoraCreación", sortOrder: "descend" }]
      });
      
      return response.data.map(record => ({
        id: record.fieldData.id,
        email: record.fieldData.email,
        full_name: record.fieldData.full_name,
        clerk_id: record.fieldData.clerk_id,
        is_admin: record.fieldData.is_admin,
        last_login: record.fieldData.last_login,
        status: record.fieldData.status,
        preferences: record.fieldData.preferences,
        created_at: record.fieldData.MarcaFechaYHoraCreación,
        updated_at: record.fieldData.MarcaFechaYHoraModificación
      }));
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  }

  /**
   * Obtener un usuario por ID
   */
  static async getUserById(id) {
    try {
      const response = await filemakerService.getRecord('yoolusers', id);
      const record = response.data;
      
      return {
        id: record.fieldData.id,
        email: record.fieldData.email,
        full_name: record.fieldData.full_name,
        clerk_id: record.fieldData.clerk_id,
        is_admin: record.fieldData.is_admin,
        last_login: record.fieldData.last_login,
        status: record.fieldData.status,
        preferences: record.fieldData.preferences,
        created_at: record.fieldData.MarcaFechaYHoraCreación,
        updated_at: record.fieldData.MarcaFechaYHoraModificación
      };
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  }

  // ... resto de métodos adaptados para FileMaker
}

export default UsersService;